import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class ContractService {

  public list: any = [];

  public programs: any = [];

  public levels: any = [];

  public contract_costs_keys: Array<string> = [
    'level',
    'is_apprendistato',
    'year',
    'classification',
    'trial',
    'notice_5_years',
    'notice_5_to_10_years',
    'notice_10_years',
    'salary_yearly_gross',
    'total_yearly',
    'total_month',
    'monthly_gross_13',
    'net_monthly_12',
    'net_monthly_13',
    'total_daily'
  ];

  public listWithVat: any = [];

  constructor(private _httpClient: HttpClient, private _utilService: UtilsService) {
  }

  async getList(defRet: any = []): Promise<any> {
    return this._httpClient.get('/contract').toPromise()
      .then(response => {
        this.listWithVat = response;
        this.list = this.listWithVat.filter(item => item.name !== 'Partita IVA');
        return response;
      })
      .catch(err => {
        console.error(err);
        return defRet;
      });
  }

  async getPrograms() {
    this.programs = [
      {
        value: 'part time',
        label: await this._utilService.translate('PARTTIME'),
      },
      {
        value: 'full time',
        label: await this._utilService.translate('FULLTIME'),
      },
    ];
  }

  async getLevels() {
    return this._utilService.basic_get('/contract-level')
      .then((result: any) => {
        this.levels = result;
        return result;
      });
  }

  async getCosts() {
    return this._utilService.basic_get('/contract/costs').then(r => r || []);
  }

  async updateCosts(data: any = []) {
    return this._httpClient.put('/contract/costs', data).toPromise();
  }

  async getAllContractUsers() {
    return this._httpClient.get('/contract/active').toPromise();
  }
}
